import _ from 'lodash';
import { lsErrorService, lsStorageService } from 'ls-vue-common';
import gql from 'graphql-tag';
import createGraphQLClient from './apolloClient';
import {
    AUTH__JWT,
    AUTH__JWT_FETCH,
    LTRS__COMPLETED_BY_SCHEDULE,
    LTRS__GET_SCHEDULE_EVENTS,
    LTRS__MUTATE_LOADING_STATUS,
    LTRS__MUTATE_SCHEDULE_EVENTS,
    LTRS__SCHEDULE_EVENTS_RECEIVED,
    LTRS__UNAUTHENTICATED_ERROR_RECEIVED,
} from '@/store/types';

const eventsByCustomerQuery = gql`
    query ScheduleEventsForAdmins($customerId: Int!) {
        ScheduleEventsForAdmins(customerId: $customerId) {
            data {
                schedule {
                    lsApiScheduleId
                    property {
                        lsApiPropertyId
                    }
                }
                windowStart
                windowEnd
                status
                startedAt
                completedAt
                notes
                productsUsed
                technician {
                    name
                }
                lsApiScheduleEventId
                updatedAt
            }
        }
    }
`;

export const mutations = {
    [LTRS__MUTATE_LOADING_STATUS](state, payload) {
        state.loadingStatus = payload;
    },

    [LTRS__MUTATE_SCHEDULE_EVENTS](state, { data }) {
        state.ltrsEvents = data;
    },
};

export const actions = {
    [LTRS__GET_SCHEDULE_EVENTS]({ commit, dispatch }, { customerId, graphQLClient }) {
        commit(LTRS__MUTATE_LOADING_STATUS, { isLoading: true });

        const jwt = lsStorageService.get(AUTH__JWT);

        const { apolloClient } = graphQLClient || createGraphQLClient(jwt);

        return apolloClient
            .query({
                query: eventsByCustomerQuery,
                variables: { customerId },
                fetchPolicy: 'no-cache',
            })
            .then(({ data }) => {
                dispatch(LTRS__SCHEDULE_EVENTS_RECEIVED, data.ScheduleEventsForAdmins);
            })
            .catch((error) => {
                const message = _.get(error, 'graphQLErrors[0].message') || '';
                if (/unauthenticated/i.test(message)) {
                    dispatch(LTRS__UNAUTHENTICATED_ERROR_RECEIVED, { customerId });
                    return;
                }
                lsErrorService.log({ error, showAlert: true });
            })
            .finally(() => {
                commit(LTRS__MUTATE_LOADING_STATUS, {
                    isLoading: false,
                });
            });
    },

    [LTRS__SCHEDULE_EVENTS_RECEIVED]({ commit }, ltrsEvents) {
        commit(LTRS__MUTATE_SCHEDULE_EVENTS, ltrsEvents);
    },

    async [LTRS__UNAUTHENTICATED_ERROR_RECEIVED]({ dispatch }, { customerId }) {
        await dispatch(AUTH__JWT_FETCH);
        await dispatch(LTRS__GET_SCHEDULE_EVENTS, { customerId });
    },
};

export const getters = {
    [LTRS__COMPLETED_BY_SCHEDULE](state) {
        const ltrsEvents = _.filter(state.ltrsEvents, (event) => {
            return event.status === 'COMPLETE';
        });
        return _.groupBy(ltrsEvents, 'schedule.lsApiScheduleId');
    },
};

export const ltrs = {
    state: { ltrsEvents: [], isLoading: false },
    mutations,
    actions,
    getters,
};
